import { createSelector } from "reselect";

import { IacTableGroupMeta } from "./makeIacTableDataSlice/types";
import { IacTableStoreState } from "./types";

export const selectGroupsMeta = createSelector(
  (state: IacTableStoreState, groupId: string) => state.groupsMeta[groupId],
  (result): IacTableGroupMeta | undefined => result
);

const selectOpenGroups = createSelector(
  (state: IacTableStoreState) => state.groupsMeta,
  (groupsMeta): string[] => {
    return Object.keys(groupsMeta).filter((groupId) => groupsMeta[groupId].isOpen);
  }
);

export const selectStickyRanges = createSelector(
  selectOpenGroups,
  (state: IacTableStoreState) => state.resourcesIdsPerGroup,
  (openGroups, resourcesIdsPerGroup): [string, string][] => {
    return openGroups.reduce<[string, string][]>((acc, groupId) => {
      if (resourcesIdsPerGroup[groupId]?.length > 0) {
        //find the last resource in the group
        const lastResource =
          resourcesIdsPerGroup[groupId][resourcesIdsPerGroup[groupId].length - 1];

        acc.push([groupId, lastResource]);
      }
      return acc;
    }, []);
  }
);
